const hoptions = [];
const voptions = [];
export const getHorizontalOptions = (HORIZONTAL_VALUES) => {
  if (hoptions.length < 1) {
    for (let i = 1; i <= HORIZONTAL_VALUES; i++) {
      hoptions.push((`value=${i}`, `${i}`));
    }
    return hoptions;
  } else return hoptions;
};

export const getVerticalOptions = (VERTICAL_VALUES) => {
  if (voptions.length < 1) {
    for (let i = 1; i <= VERTICAL_VALUES; i++) {
      voptions.push((`value=${i}`, `${i}`));
    }
    return voptions;
  } else return voptions;
};
